import {
  IconButton,
  LinearProgress,
  Chip,
  makeStyles,
  Typography,
} from '@material-ui/core'

import { map, filter } from 'lodash'

import { Clear, Refresh } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  section: {
    width: '100%',
    marginTop: '10px',
    //#D3D5D8
  },
  mainContainer: {
    display: 'flex',
    padding: '10px 0',
  },

  leftWrap: {
    width: 'Calc( 100% - 80px)',
  },
  textContainer: {
    paddingBottom: 5,
  },
  rightWrap: {
    display: 'flex',
  },
  greenProgress: {
    '& .MuiLinearProgress-bar1Determinate': {
      backgroundColor: 'green',
    },
  },
  slowProgress: {
    '& .MuiLinearProgress-bar1Determinate': {
      backgroundColor: '#AE570F',
    },
  },
  slowError: {
    color: '#AE570F',
    fontSize: 12,
  },
  uploadError: {
    color: 'red',
    fontSize: 12,
  },
  errorContainer: {
    display: 'flex',
    padding: '10px 0',
    '& .MuiLinearProgress-bar1Determinate': {
      backgroundColor: 'red',
    },
  },
}))

const FilesList = ({
  files = [],
  removeFiles = () => {},
  fileCategory,
  uploadFileHandler = () => {},
}) => {
  const filesData = filter(files, (file) => file.fileCategory === fileCategory)
  const chipsData = filter(
    filesData,
    (file) =>
      file.progress === 100 &&
      file.status === 'success' &&
      file.fileCategory === fileCategory
  )

  const styles = useStyles()
  return (
    <div className={styles.section}>
      {map(filesData, (file, key) => (
        <div
          key={key}
          className={`${
            file.status === 'error'
              ? styles.errorContainer
              : styles.mainContainer
          }`}
        >
          <div className={styles.leftWrap}>
            <div className={styles.textContainer}>
              <span
                style={{
                  display: 'inline-block',
                  width: '49%',
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {file.name}
              </span>
              <span
                style={{
                  display: 'inline-block',
                  width: '49%',
                  textAlign: 'right',
                  fontSize: 12,
                }}
              >
                {' '}
                {file.status === 'error'
                  ? '-'
                  : Math.round(file.progress) + '%'}{' '}
              </span>
            </div>

            <LinearProgress
              className={
                file.slowConnection && file.progress !== 100
                  ? styles.slowProgress
                  : file.progress === 100
                  ? styles.greenProgress
                  : ''
              }
              variant="determinate"
              value={file.progress}
            />
            {file.slowConnection &&
            file.status !== 'error' &&
            file.progress !== 100 ? (
              <span className={styles.slowError}>
                Network connectivity slow. please check your connectivity and
                try again.
              </span>
            ) : (
              ''
            )}
            {file.status === 'error' ? (
              <span className={styles.uploadError}>
                Error occured while uploading file. Please try again.
              </span>
            ) : (
              ''
            )}
          </div>
          <div className={styles.rightWrap}>
            <IconButton onClick={() => removeFiles(file.name)}>
              <Clear />
            </IconButton>

            {file.status === 'error' && (
              <IconButton
                onClick={() => {
                  removeFiles(file.name)
                  setTimeout(() => {
                    uploadFileHandler(file.file, fileCategory)
                  }, 100)
                }}
              >
                <Refresh />
              </IconButton>
            )}
          </div>
        </div>
      ))}

      {chipsData.length ? (
        <>
          <Typography
            variant="h3"
            style={{ marginBottom: 10, fontSize: 14, fontWeight: 500 }}
          >
            Uploaded Files
          </Typography>
          {map(
            files,
            (file, key) =>
              file.progress === 100 && (
                <Chip
                  label={file.name}
                  onDelete={() => removeFiles(key)}
                  color="tertiary"
                  deleteIcon={<Clear />}
                  variant="outlined"
                />
              )
          )}
        </>
      ) : (
        ''
      )}
    </div>
  )
}

export default FilesList
